<template>
  <div id="app">
    <LeftMenu :isMode="isMode" />
    <!-- 主要内容 -->
    <div
      :class="{
        fmContent: true,
        fmContentTwo: isMode == 'Hide',
        fmContentThree: $route.name == 'notice',
      }"
    >
      <!-- 公共头部 -->
      <NavBar :isMode="isMode"></NavBar>
      <div
        :class="{
          fmGFans: true,
          fmGfansNote: $route.name == 'notice',
        }"
      >
        <!-- 未获取到登录信息的占位骨架屏组件 -->
        <!-- <router-view v-if="$store.state.isapp == 1" /> -->
        <keep-alive :include="cachedViews">
          <router-view
            v-if="$store.state.isapp == 1 && isRouterAlive"
          ></router-view>
        </keep-alive>
        <NotCenter v-if="$store.state.isapp == 0" />
        <!-- 全局下载组件 -->
        <fmDownload></fmDownload>
        <RightMenu v-show="shouldShowRightMenu" :isMode="isMode" />
      </div>
    </div>
    <!-- 返回顶部按钮 -->
    <div
      :class="{
        backTop: true,
        backTopTwo: isMode == 'leftHide',
        backTopThree: isMode == 'rightHide' || isMode == 'Hide',
        show: showBackTop,
      }"
      @click="scrollToTop"
    >
      <svg-btn class="icon" icon-class="icon-top"></svg-btn>
    </div>
    <!-- 登录引导弹窗 -->
    <LoginTip />
  </div>
</template>
<script>
import NavBar from '@/components/NavBar/index.vue'
import LeftMenu from '@/components/LeftMenu/index.vue'
import NotCenter from '@/components/NotCenter/index.vue'
import RightMenu from '@/components/RightMenu/index.vue'
import LoginTip from '@/components/loginTip/index.vue'
import fmDownload from '@/components/FmDownload'
import { eventBus } from '@/utils/event-bus'
export default {
  name: 'App',
  components: {
    NavBar,
    LeftMenu,
    RightMenu,
    LoginTip,
    NotCenter,
    fmDownload,
  },
  data() {
    return {
      showBackTop: false,
      isRouterAlive: true,
      cachedViews: ['home', 'subscribe', 'user'],
    }
  },
  computed: {
    currentTheme() {
      return this.$store.state.theme // 从Vuex中获取当前的主题值
    },
    isMode() {
      return this.$store.getters['device/deviceClass']
    },
    shouldShowRightMenu() {
      return (
        this.isMode != 'rightHide' &&
        this.isMode != 'Hide' &&
        this.$route.name != 'notice'
      )
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      const bodyElement = document.documentElement
      bodyElement.classList.remove(oldVal)
      bodyElement.classList.add(newVal)
      bodyElement.setAttribute('data-theme', newVal)
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    // 监听全局reload事件
    eventBus.$on('appReload', () => {
      this.reload()
    })
  },
  mounted() {
    // 初始化设备监听
    this.$store.dispatch('device/initResizeListener')
    // 立即更新一次设备状态（处理初始加载）
    this.$store.commit('device/UPDATE_DEVICE_CLASS')
    window.addEventListener('scroll', this.handleScroll)
    const bodyElement = document.documentElement
    bodyElement.setAttribute('data-theme', this.currentTheme)
    bodyElement.classList.add('html-theme')
    if (this.currentTheme == 'light') {
      bodyElement.classList.add('light')
      bodyElement.classList.remove('dark')
    } else {
      bodyElement.classList.remove('light')
      bodyElement.classList.add('dark')
    }
  },
  beforeDestroy() {
    // 组件销毁时移除监听
    eventBus.$off('appReload')
  },
  methods: {
    reload: _.debounce(
      function () {
        this.isRouterAlive = false
        this.$nextTick(function () {
          this.isRouterAlive = true
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    handleScroll() {
      // 注释的是滚动要超出一屏高度，才会执行
      // this.showBackTop = window.scrollY > window.innerHeight
      // 适配taptap按钮出现
      this.showBackTop = window.scrollY > 230
    },
    scrollToTop() {
      // 平滑滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
#app {
  display: flex;
  justify-content: center;
  width: 100%;
  min-height: 100vh;
  // height: 100vh;
  @include useTheme {
    background: getVar('bg-color');
  }
  .fmContent {
    display: flex;
    flex-direction: column;
    .fmGFans {
      display: flex;
      min-height: calc(100vh - 72px);
      transition: min-height 0.2s ease;
    }
    // .fmGfansNote {
    //   min-height: 100vh !important;
    // }
  }
  .fmContentTwo {
    width: 0;
    flex: 1;
    padding-right: 10px;
  }
  .backTop {
    position: fixed;
    left: calc(50% + 560px);
    // bottom: 32px;
    bottom: 84px;
    width: 48px;
    height: 48px;
    box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.08);
    border-radius: 50%;
    z-index: 201;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    visibility: hidden;
    @include useTheme {
      color: getVar('text-color3-90969c');
      border: 1px solid getVar('border-color1');
      background: getVar('bg-color-content');
    }
    &:hover {
      @include useTheme {
        color: getVar('text-color1-2c2c2c');
      }
    }
    .icon {
      width: 24px;
      height: 24px;
    }
  }
  .backTopTwo {
    left: calc(50% + 421px);
  }
  .backTopThree {
    left: calc(100vw - 80px);
  }
  .show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}
</style>
